import React from 'react';

function WizardHeading({ text, style = null }) {
  return (
    <h6
      id={`wizardheading-${text}`}
      data-testid={`wizardheading-${text}`}
      className="flex-xy-center"
      style={{
        fontWeight: 'bold',
        fontSize: 18,
        lineHeight: '21px',
        height: '36px',
        ...style,
      }}
    >
      {text}
    </h6>
  );
}

export default WizardHeading;
